module.exports = __webpack_public_path__ + "static/media/wordcloud_list.afe80839.csv";